{
  "Accessibility menu": "Tilgængelighedsmenu",
  "Reset settings": "Nulstil indstillinger",
  "Close": "Luk",
  "Content adjustments": "Indholdsjusteringer",
  "Navigation adjustments": "Navigationsjusteringer",
  "Align Left": "Venstrejuster",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhæv titel",
  "Highlight Links": "Fremhæv links",
  "Readable Font": "Læsbar skrifttype",
  "Colour adjustments": "Farvejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høj kontrast",
  "High Saturation": "Høj mætning",
  "Low Saturation": "Lav mætning",
  "Monochrome": "Monokrom",
  "Tools": "Værktøjer",
  "Reading Guide": "Læseguide",
  "Stop Animations": "Stop animationer",
  "Big Cursor": "Stor markør",
  "Increase Font Size": "Forøg skriftstørrelse",
  "Decrease Font Size": "Formindsk skriftstørrelse",
  "Letter Spacing": "Bogstavafstand",
  "Line Height": "Linjehøjde",
  "Font Weight": "Skrifttykkelse",
  "Dyslexia Font": "Skrifttype til ordblindhed",
  "Language": "Sprog",
  "Accessibility widget": "Åbn tilgængelighedsmenu",
  "Accessibility Profiles": "Tilgængelighedsprofiler",
  "Cognitive Disability": "Kognitiv handicap",
  "Seizure Safe": "Anfaldsikker",
  "Accessibility statement": "Tilgængelighedserklæring"
}